import React from 'react';

type ErrorSummaryProps = {
  errorMessages: Array<{ id: string, errorMessage: string }>
  label: string
}

export function SVVErrorSummary(
  {
    errorMessages,
    label
  }: ErrorSummaryProps
) {
  return (
    <div className="svv-form-error-summary editorial">
      <p>
        {label}
      </p>
      <ul>
        {errorMessages.map(m => (
          <li key={m.id}>
            <a
              href={`#${m.id}`}
              className="svv-form-error-summary--link"
            >
              {m.errorMessage}
            </a>
          </li>
        ))}
      </ul>
    </div>
  );
}

SVVErrorSummary.displayName = "SVVErrorSummary";
